import React, { useMemo } from 'react';
import { Modal, ModalHeader, ModalContent } from '@msi/cobalt-react/modal';
import { useOktaAuth } from '@okta/okta-react';
import './UserProfileModal.css';

interface UserProfileModalProps {
    isOpen: boolean;
    onClose: () => void;
}

const UserProfileModal: React.FC<UserProfileModalProps> = ({ isOpen, onClose }) => {
    const { authState } = useOktaAuth();
    const claims = authState?.accessToken?.claims as Record<string, unknown> | undefined;
    const idTokenClaims = authState?.idToken?.claims;

    const fullName = (claims?.Name as string) || '';
    const nameParts = fullName.trim().split(/\s+/);
    const firstName = nameParts[0] || '--';
    const lastName = nameParts.length > 1 ? nameParts[nameParts.length - 1] : '--';
    const middleName = nameParts.length > 2 ? nameParts.slice(1, -1).join(' ') : '--';
    const email = (claims?.email as string) || '--';

    const amr = idTokenClaims?.amr as string[] | undefined;
    const authType = amr?.length ? 'Multifactor Authentication' : 'Standard Authentication';

    const modalStyle = useMemo(() => ({
        overlay: { zIndex: 10000 },
        content: { zIndex: 10001 },
    }), []);

    return (
        <Modal handleCloseModal={onClose} showModal={isOpen} style={modalStyle}>
            <ModalHeader>User Profile</ModalHeader>
            <ModalContent>
                <div className="user-profile-content">
                    <div className="user-profile-card">
                        <h3 className="user-profile-section-title">Personal Details</h3>
                        <div className="user-profile-grid user-profile-grid--3col">
                            <div className="user-profile-field">
                                <span className="user-profile-label">First Name</span>
                                <span className="user-profile-value">{firstName}</span>
                            </div>
                            <div className="user-profile-field">
                                <span className="user-profile-label">Middle Name</span>
                                <span className="user-profile-value">{middleName}</span>
                            </div>
                            <div className="user-profile-field">
                                <span className="user-profile-label">Last Name</span>
                                <span className="user-profile-value">{lastName}</span>
                            </div>
                        </div>
                        <h3 className="user-profile-section-title" style={{ marginTop: 24 }}>Account Details</h3>
                        <div className="user-profile-grid user-profile-grid--2col">
                            <div className="user-profile-field">
                                <span className="user-profile-label">Language</span>
                                <span className="user-profile-value">English</span>
                            </div>
                            <div className="user-profile-field">
                                <span className="user-profile-label">Authorization Type</span>
                                <span className="user-profile-value">{authType}</span>
                            </div>
                        </div>
                    </div>
                    <div className="user-profile-card">
                        <h3 className="user-profile-section-title">Email Address</h3>
                        <div className="user-profile-grid user-profile-grid--2col">
                            <div className="user-profile-field">
                                <span className="user-profile-label">Type</span>
                                <span className="user-profile-value">Primary</span>
                            </div>
                            <div className="user-profile-field">
                                <span className="user-profile-label">Email Address</span>
                                <span className="user-profile-value">{email}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </ModalContent>
        </Modal>
    );
};

export default UserProfileModal;
